import { useState, useEffect, useMemo } from 'react';
import { listConsultorioMembers } from '../api';

/** Carga el equipo del consultorio (o solo el usuario actual). */
export function useConsultorioEquipo(user) {
  const [equipo, setEquipo] = useState([]);

  useEffect(() => {
    if (!user?.id) {
      setEquipo([]);
      return;
    }
    if (!user?.tenant_id) {
      setEquipo([{
        customer_id: user.id,
        full_name: user.nombre || 'Yo',
        role: user.consultorio_role || user.rol,
      }]);
      return;
    }
    let cancelled = false;
    listConsultorioMembers()
      .then(({ data }) => {
        if (cancelled) return;
        if (Array.isArray(data) && data.length > 0) setEquipo(data);
        else {
          setEquipo([{
            customer_id: user.id,
            full_name: user.nombre || 'Yo',
            role: user.consultorio_role || user.rol,
          }]);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setEquipo([{
            customer_id: user.id,
            full_name: user.nombre || 'Yo',
            role: user.consultorio_role || user.rol,
          }]);
        }
      });
    return () => { cancelled = true; };
  }, [user?.id, user?.tenant_id, user?.nombre, user?.consultorio_role, user?.rol]);

  const equipoIds = useMemo(
    () => equipo.map((m) => m.customer_id).filter((x) => x != null && x !== ''),
    [equipo],
  );

  return { equipo, equipoIds };
}
